export default __webpack_public_path__ + "static/media/sound-off.9f2ea3df.png";